/* eslint-disable */

import {useEffect, useRef} from "react"
import {mousemove} from "utils/Helpers";
import {useSelector} from "react-redux";

const MouseMove = (props) => {

    const accessible = useSelector(state => state.accessible);

    function mousemove(e, moveEvent, backGround, extraBackGround, midGround, bonusGround){

        let moveLimit = 200;

        let w      = window.innerWidth;
        let h      = window.innerHeight;
        let center = { x: w/2, y: h/2 };

        if(e){

            let evX = (moveEvent === 'touchmove') ? e.touches[0].clientX : e.clientX;
            let evY = (moveEvent === 'touchmove') ? e.touches[0].clientY : e.clientY;

            let moveX = (center.x - evX) / 60;
            let moveY = (center.y - evY) / 60;

            moveX = (moveX > moveLimit) ? moveLimit : moveX;
            moveX = (moveX < moveLimit*-1) ? moveLimit*-1 : moveX;
            moveY = (moveY > moveLimit) ? moveLimit : moveY;
            moveY = (moveY < moveLimit*-1) ? moveLimit*-1 : moveY;

            let shift = 2;

            if(backGround) {
                backGround.style.marginLeft =  Math.ceil(moveX) + 'px';
                backGround.style.marginTop =  Math.ceil(moveY) + 'px';
            }

            if(extraBackGround) {
                extraBackGround.style.transform = `translateX(${ (Math.ceil(moveX) * shift)}px) translateY(${(Math.ceil(moveY) * shift)}px)`
                shift = shift + 2;
            }

            if(midGround) {
                midGround.style.transform = `translateX(${ (Math.ceil(moveX) * shift)}px) translateY(${(Math.ceil(moveY) * shift)}px)`;
                shift = shift + 2;
            }

            if(bonusGround) {
                bonusGround.style.transform = `translateX(${ (Math.ceil(moveX) * shift)}px) translateY(${(Math.ceil(moveY) * shift)}px)`;
            }

        }

    }

    useEffect(()=>{

        let extraBackGround = props.extraBackGround ? props.extraBackGround.current : null;
        let midGround = props.midGround ? props.midGround.current : null;
        let bonusGround = props.bonusGround ? props.bonusGround.current : null;

        let moveEvent = ('ontouchstart' in document.documentElement) ? "touchmove" : "mousemove";
        let mouseMoveFunction = (e) => mousemove(e, moveEvent, props.backGround.current, extraBackGround, midGround, bonusGround );

        if(!accessible.exploring && props.status === 'active') window.addEventListener(moveEvent, mouseMoveFunction);
        else window.removeEventListener(moveEvent, mouseMoveFunction);
        return () => window.removeEventListener(moveEvent, mouseMoveFunction);

    }, [accessible.exploring, props.status]);



    return <></>;

}

export default MouseMove;